<template>
	<router-link :to="link" class="company">
		<img
            :src="rowData.country.flag || '//placehold.it/24x16'"
            :alt="rowData.country.name"
            class="flag"
            v-tippy="rowData.country.name"
        />
		<span>{{ (rowData.companyName)?rowData.companyName:rowData.projectName }}</span>
	</router-link>
</template>

<script>
	export default {
		name: 'ColumnCompany',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		computed: {
			link() {
				if(this.rowData.status === 2) {
					return { name: 'view-madd', params: { madd_id: this.rowData.id }}
				} else {
					return { name: 'madd-preview', params: { madd_id: this.rowData.id }}
				}
			}
		}
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>

<style lang="scss" scoped>
	@import "~reflex-grid/scss/includes/variables";
	@import "~reflex-grid/scss/includes/mixins";
	@import "~@/theme/_variables.scss";

	.company {
		@include display-flex;
		@include align-items(center);
	}

	.flag {
		margin-right: 1.5rem;
		max-width: 2.4rem;
		height: auto;
		@include flex(0, 0, auto);
	}
</style>
